import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { LocaleContext } from 'libs.nucleus';
import { fetchParticipantTimeline } from './helpers/fetch_participant_timeline.helpers';
import { useCurrentEnvironment } from '../../hooks/use_current_environment';
/**
 * Phase B: fetches the participant's events + scheduler notification records (c_notif) from the
 * current environment and joins them. Notifications are read through the site-scoped Axon route, so
 * `siteId` is required. Polls every 5s while the backend reports the schedule is still generating.
 */
export const useParticipantEventTimeline = (participantId, siteId) => {
    const { environment } = useCurrentEnvironment();
    const locale = useContext(LocaleContext);
    const { data, isLoading, isError } = useQuery({
        queryKey: ['participantEventTimeline', environment?.id, siteId, participantId, locale],
        queryFn: async () => {
            if (!environment) {
                return { participantId, generating: false, events: [] };
            }
            return fetchParticipantTimeline({ environment, participantId, siteId, locale });
        },
        enabled: !!environment && !!participantId && !!siteId,
        refetchInterval: (query) => (query.state.data?.generating ? 5000 : false),
    });
    return { data, isLoading, isError };
};
